import firebase from 'firebase/app'
import 'firebase/firestore'
import NumberHelpers from '../helpers/NumberHelpers'
import Firestore from './Firestore'

var fs = firebase.firestore()

export default class {
    constructor() {
        this._items = []
    }

    get items() {
        return this._items || []
    }
    set items(newVal) {
        this._items = newVal
    }
    get item() {
        return this._item || {}
    }
    set item(newVal) {
        this._item = newVal
    }

    ref(path) {
        this._path = path
        const segments = path.split('/')
        const numSegments = segments.length
        //Collection...
        if(NumberHelpers.isOdd(numSegments)) {
            this._baseRef = fs.collection(path)
            this._ref = this._baseRef
            this._single = false
        }
        //Document...
        else {
            const base = segments.slice(0, numSegments - 1).join('/')
            this._id = segments[numSegments - 1]
            this._baseRef = fs.collection(base)
            this._ref = this._baseRef.doc(this._id)
            this._single = true
        }
        return this
    }

    where(field, operator, val) {
        this._ref = this._baseRef.where(field, operator, val)
        return this
    }

    fetch(limit = 100) {
        return new Promise( (resolve, reject) => {
            if(this._single) {
                this._ref.get().then(doc => {
                    if(doc.exists) {
                        Vue.set(this, '_item', doc.data())
                        resolve(doc.data())
                    }
                    else {
                        this._item = {}
                        resolve({})
                    }
                })
            } else {
                this._ref.limit(limit).get().then(snap => {
                    
                    snap.forEach(doc => {
                        const item = Firestore.convertDates(doc.data() )
                        item._id = doc.id
                        item._db = this
                        this._items.push(item)
    
                    })
                    resolve(this._items)
                })               
            }        
        })
    }

    saveItem(item, options = {}) {  
        const id = item._id
        item = prepareItemForStorage(item)
        if(options.timestamp)
            Firestore.addTimestamp(item)
        if(options.author)
            Firestore.addAuthor(item)
        if(options.owner)
            Firestore.addOwner(item)

        console.log('Db.saveItem is saving...', item)

        this._baseRef.doc(id).set(item)
    }


} // end class

const prepareItemForStorage = function(obj) {
    let newObj = Object.assign({}, obj)
    for(let prop in newObj) {
        if(prop.substr(0,1) == '_')
            delete newObj[prop]
    }
    return newObj
}


// WEBPACK FOOTER //
// ./src/data/Db.js